export const queryKeys = Object.freeze({
  adminInfoFieldTypes: () => ['adminInfoFieldTypes'],
  adminInfo: (companyId) => ['adminInfo', companyId],
});
